import OwlCarousel from 'react-owl-carousel';  
export default function BrandFour(){
    return(
        <>
            <div class="brand-area home-4">
                <div class="container">
                <OwlCarousel items={5}  
                        className="owl-theme brand-slide2"  
                        loop 
                        center={true}
                        dots={false}			  
                        margin={30} >
                             <div class="brand-item">
                                <a class="brand-img" to="#">
                                    <img class="front" src="assets/img/home-4/c-2.png" alt="Brand" />
                                    <img class="back" src="assets/img/home-4/c-2.png" alt="Brand" />
                                </a>
					        </div>	
                            <div class="brand-item">
                                <a class="brand-img" to="#">
                                    <img class="front" src="assets/img/home-4/c-4.png" alt="Brand" />
                                    <img class="back" src="assets/img/home-4/c-4.png" alt="Brand" />
                                </a>
					        </div>	

                            <div class="brand-item">
                                <a class="brand-img" to="#">
                                    <img class="front" src="assets/img/home-4/c-4.png" alt="Brand" />
                                    <img class="back" src="assets/img/home-4/c-4.png" alt="Brand" />
                                </a>
					        </div>	
                            <div class="brand-item">
                                <a class="brand-img" to="#">
                                    <img class="front" src="assets/img/home-4/c-5.png" alt="Brand" />
                                    <img class="back" src="assets/img/home-4/c-5.png" alt="Brand" />
                                </a>
					        </div>	
                            <div class="brand-item">
                                <a class="brand-img" to="#">
                                    <img class="front" src="assets/img/home-4/c-6.png" alt="Brand" />
                                    <img class="back" src="assets/img/home-4/c-6.png" alt="Brand" />
                                </a>
					        </div>	
                            <div class="brand-item">
                                <a class="brand-img" to="#">
                                    <img class="front" src="assets/img/home-4/c-1.png" alt="Brand" />
                                    <img class="back" src="assets/img/home-4/c-1.png" alt="Brand" />
                                </a>
					        </div>	
                            <div class="brand-item">
                                <a class="brand-img" to="#">
                                    <img class="front" src="assets/img/home-4/c-2.png" alt="Brand" />
                                    <img class="back" src="assets/img/home-4/c-2.png" alt="Brand" />
                                </a>
					        </div>	
                </OwlCarousel>
				
            </div>
        </div>
        </>
    )
}